@if (questionnaire) {
  <panel width="650">
    <menu always-visible>
      <menuitem (click)="changeQuestionnaireName()">{{ 'questionnaire.change-name' | translate }}</menuitem>
    </menu>
    <h1>{{ questionnaire.name }}</h1>
    <div class="row">
      <div class="col-6">
        <submit-button [ignoreValidation]="true" (click)="addNewQuestion()" [label]="'questionnaire.add-new-question' | translate" />
      </div>
      <div class="col-6">
        <submit-button [ignoreValidation]="true" (click)="openExistingQuestions()" [label]="'questionnaire.add-existing-question-from-list' | translate" />
      </div>
    </div>
    <div class="panel-section scrollable">
      <div class="category" prefixIcon="fas fa-home">
        <div class="text-bold-3">{{ 'questionnaire.category.' + questionCategoryTypeEnum[questionCategoryTypeEnum.Company] | translate }}</div>
        @if (companyQuestionnaireQuestions.length > 0) {
          <ul class="bullet-list">
            @for (questionnaireQuestion of companyQuestionnaireQuestions; track questionnaireQuestion) {
              <li
                [ngClass]="{ 'selected': questionnaireQuestion == selectedQuestionnaireQuestion }"
                [sortable]="companyQuestionnaireQuestions"
                (itemsChange)="companyQuestionnaireQuestions = $event"
                [item]="questionnaireQuestion"
                (sortend)="saveQuestionnaireQuestionSorting(companyQuestionnaireQuestions)"
                handleSelector=".handle">
                <div class="text-block" (click)="selectQuestion(questionnaireQuestion)">{{ questionnaireQuestion.question?.questionText }}</div>
                <div class="action-menu">
                  <icon type="up-down" class="handle" />
                  <custom-input [inputType]="inputTypeEnum.Switch"
                    title="{{ 'general.required' | translate }}"
                    [(value)]="questionnaireQuestion.required"
                  (valueChange)="requiredStatusChanged(questionnaireQuestion)"></custom-input>
                  <div class="text-warning" (click)="removeQuestionFromQuestionnaire(questionnaireQuestion)" title="{{ 'general.remove' | translate }}"><icon type="times" /></div>
                </div>
              </li>
            }
          </ul>
        }
        @if (companyQuestionnaireQuestions.length == 0) {
          <div>{{ 'general.no-results' | translate }}</div>
        }
      </div>
      <div class="category" prefixIcon="far fa-clipboard-list">
        <div class="text-bold-3">{{ 'questionnaire.category.' + questionCategoryTypeEnum[questionCategoryTypeEnum.Order] | translate }}</div>
        @if (orderQuestionnaireQuestions.length > 0) {
          <ul class="bullet-list">
            @for (questionnaireQuestion of orderQuestionnaireQuestions; track questionnaireQuestion) {
              <li
                [ngClass]="{ 'selected': questionnaireQuestion == selectedQuestionnaireQuestion }"
                [sortable]="orderQuestionnaireQuestions"
                (itemsChange)="orderQuestionnaireQuestions = $event"
                [item]="questionnaireQuestion"
                (sortend)="saveQuestionnaireQuestionSorting(orderQuestionnaireQuestions)"
                handleSelector=".handle">
                <div class="text-block" (click)="selectQuestion(questionnaireQuestion)">{{ questionnaireQuestion.question?.questionText }}</div>
                <div class="action-menu">
                  <icon type="up-down" class="handle" />
                  <custom-input [inputType]="inputTypeEnum.Switch"
                    title="{{ 'general.required' | translate }}"
                    [(value)]="questionnaireQuestion.required"
                  (valueChange)="requiredStatusChanged(questionnaireQuestion)"></custom-input>
                  <div class="text-warning" (click)="removeQuestionFromQuestionnaire(questionnaireQuestion)" title="{{ 'general.remove' | translate }}"><icon type="times" /></div>
                </div>
              </li>
            }
          </ul>
        }
        @if (orderQuestionnaireQuestions.length == 0) {
          <div>{{ 'general.no-results' | translate }}</div>
        }
      </div>
      <div class="category" prefixIcon="fas fa-tag">
        <div class="text-bold-3">{{ 'questionnaire.category.' + questionCategoryTypeEnum[questionCategoryTypeEnum.Product] | translate }}</div>
        @if (productsWithQuestions.length > 0) {
          @for (product of productsWithQuestions; track product) {
            <div>
              <div class="text-3 product-name">{{ product.name }}</div>
              <ul class="bullet-list">
                @for (questionnaireQuestion of productQuestionnaireQuestions; track questionnaireQuestion) {
                  @if (showQuestionsForProduct(questionnaireQuestion.question!, product)) {
                    <li
                      [ngClass]="{ 'selected': questionnaireQuestion == selectedQuestionnaireQuestion }"
                      [sortable]="productQuestionnaireQuestions"
                      (itemsChange)="productQuestionnaireQuestions = $event"
                      [item]="questionnaireQuestion"
                      (sortend)="saveQuestionnaireQuestionSorting(productQuestionnaireQuestions)"
                      handleSelector=".handle">
                      <div class="text-block" (click)="selectQuestion(questionnaireQuestion)">{{ questionnaireQuestion.question?.questionText }}</div>
                      <div class="action-menu">
                        <icon type="up-down" class="handle" />
                        <custom-input [inputType]="inputTypeEnum.Switch"
                          title="{{ 'general.required' | translate }}"
                          [(value)]="questionnaireQuestion.required"
                        (valueChange)="requiredStatusChanged(questionnaireQuestion)"></custom-input>
                        <div class="text-warning" (click)="removeQuestionFromQuestionnaire(questionnaireQuestion)" title="{{ 'general.remove' | translate }}"><icon type="times" /></div>
                      </div>
                    </li>
                  }
                }
              </ul>
            </div>
          }
        }
        @if (productsWithQuestions.length == 0) {
          <div>{{ 'general.no-results' | translate }}</div>
        }
      </div>
    </div>
  </panel>
}

@if (selectedQuestionnaireQuestion) {
  <edit-questionnaire-question [questionnaireQuestion]="selectedQuestionnaireQuestion" />
}

@if (showExistingQuestionList) {
  <panel width="450">
    <h1>{{ 'questionnaire.add-existing-question' | translate }}</h1>
    <div class="panel-section scrollable">
      <div class="category" prefixIcon="fas fa-home">
        <div div class="text-bold-3">{{ 'questionnaire.category.' + questionCategoryTypeEnum[questionCategoryTypeEnum.Company] | translate }}</div>
        @if (unassignedCompanyQuestions.length > 0) {
          <ul class="bullet-list">
            @for (question of unassignedCompanyQuestions; track question) {
              <li (click)="addQuestionToQuestionnaire(question.id!)">
                <div class="text-block">{{ question.questionText }}</div>
              </li>
            }
          </ul>
        }
        @if (unassignedCompanyQuestions.length == 0) {
          <div>{{ 'general.no-results' | translate }}</div>
        }
      </div>
      <div class="category" prefixIcon="far fa-clipboard-list">
        <div div class="text-bold-3">{{ 'questionnaire.category.' + questionCategoryTypeEnum[questionCategoryTypeEnum.Order] | translate }}</div>
        @if (unassignedOrderQuestions.length > 0) {
          <ul class="bullet-list">
            @for (question of unassignedOrderQuestions; track question) {
              <li (click)="addQuestionToQuestionnaire(question.id!)">
                <div class="text-block">{{ question.questionText }}</div>
              </li>
            }
          </ul>
        }
        @if (unassignedOrderQuestions.length == 0) {
          <div>{{ 'general.no-results' | translate }}</div>
        }
      </div>
      <div class="category" prefixIcon="fas fa-tag">
        <div div class="text-bold-3">{{ 'questionnaire.category.' + questionCategoryTypeEnum[questionCategoryTypeEnum.Product] | translate }}</div>
        @if (unassignedProductQuestions.length > 0) {
          <ul class="bullet-list">
            @for (question of unassignedProductQuestions; track question) {
              <li (click)="addQuestionToQuestionnaire(question.id!)">
                <div class="text-block">{{ question.questionText }}</div>
              </li>
            }
          </ul>
        }
        @if (unassignedProductQuestions.length == 0) {
          <div>{{ 'general.no-results' | translate }}</div>
        }
      </div>
    </div>
  </panel>
}
